








































































































import { UserGuideApi } from '@/api/user-guide';
import loading from '@/components/loading.vue';
import userManager from '@/services/user-manager/user-manager';
import { User } from '@/shared/user';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

const userGuideApi = new UserGuideApi();

@Component({
    components: {
        loading,
    },
})
export default class NavigationBar extends Vue {
    @userModule.Getter('user') private user!: User;
    @userModule.Getter('isAdministrator') private isAdministrator!: boolean;
    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;
    @userModule.Getter('isLegalAdvisor') private isLegalAdvisor!: boolean;
    @userModule.Getter('isCustomerExperienceExecutive') private isCustomerExperienceExecutive!: boolean;
    @userModule.Getter('isCustomerExperienceExecutiveTeamLeader') private isCustomerExperienceExecutiveTeamLeader!: boolean;
    @userModule.Getter('isDataCreationExecutive') private isDataCreationExecutive!: boolean;
    @userModule.Getter('isDataCreationTeamLeader') private isDataCreationTeamLeader!: boolean;
    @userModule.Getter('isHeadOfDepartment') private isHeadOfDepartment!: boolean;

    private showLogoutConfirmation: boolean = false;
    private isLoading: boolean = false;

    private get userInitials(): string {
        return `${this.user.firstName == null ? null : this.user.firstName.substr(0, 1)}${this.user.lastName == null ? null : this.user.lastName.substr(0, 1)}`;
    }

    private get changePasswordUrl(): string {
        return process.env.NODE_ENV !== 'production'
            ? `${process.env.VUE_APP_IDENTITY_AUTHORITY_URL}/change-password`
            : `https://account.${window.location.host}/change-password`;
    }

    private onLogout(): void {
        this.showLogoutConfirmation = true;
    }

    private onCancel(): void {
        this.showLogoutConfirmation = false;
    }

    private async onDownloadUserGuideAsync(): Promise<void> {
        const response = await userGuideApi.getUserGuide('Concerto User Guide.docx');
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const link = document.createElement('a');
        link.rel = 'noopener';
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Concerto User Guide.docx';
        link.target = '_blank';
        link.click();
        window.URL.revokeObjectURL(link.href);
    }

    private async onLogoutConfirmedAsync(): Promise<void> {
        this.isLoading = true;
        await userManager.signoutRedirect();
    }

    private onToggleMenu(): void {
        this.$emit('toggle-menu');
    }

    private onShowUserMenu(): void {
        alert(`Hello ${this.user.firstName}`);
    }
}
